import React from 'react'
import { Pane } from 'evergreen-ui'

export default ({ children, float }) => <Pane display='flex' alignItems='stretch' height='100%' float={float}>
    {children}
</Pane>